import React, {
  Suspense, lazy, ComponentType,
} from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

const GilroyFallbackWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
`;

const GilroyFallback = function GilroyFallback() {
  return (
    <GilroyFallbackWrap>
      <Spin size="small" />
    </GilroyFallbackWrap>
  );
};

const withGilroySuspense = (LazyComponent: React.LazyExoticComponent<ComponentType<any>>) => {
  const Wrapped = function WrappedGilroy(props: Record<string, unknown>) {
    return (
      <Suspense fallback={<GilroyFallback />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
  return Wrapped;
};

const GilroyLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.Gilroy })));
const StatesAndActionsWrapperLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.StatesAndActionsWrapper })));
const CustomTabGilroyLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.CustomTabGilroy })));
const ChatbotV2FullSkeletonLazy = lazy(() => import('gilroy-global').then((m) => ({ default: m.ChatbotV2FullSkeleton })));

export const Gilroy = withGilroySuspense(GilroyLazy);
export const StatesAndActionsWrapper = withGilroySuspense(StatesAndActionsWrapperLazy);
export const CustomTabGilroy = withGilroySuspense(CustomTabGilroyLazy);
export const ChatbotV2FullSkeleton = withGilroySuspense(ChatbotV2FullSkeletonLazy);

export const loadGilroyActions = () => import('gilroy-global').then((m) => m.actions);
